fx.translations("it", {
     "Commander" : "Ordinare",
     "Sauver & Quitter" : "Salva e Esci",
     "(hors livraison) :" : "(esclusa la consegna) :",
     "Votre ouvrage contient" :  "La tua opera contiene",
     "pages": "pagine",

     "Carré" : "Quadrato",
     "Portrait" : "Ritratto",
     "Paysage" : "Paesaggio",

     "Rechercher" : "Cercare",
     "Ajouter" : "Aggiungere",
     "Modifier" : "Modificare",

     "Couleur" : "Colore",

     "Réglages" : "Impostazioni",

     "Prix" : "Prezzo",

     "Album"  : "Album",

     "Recommandés" : "Consigliati",

     "Photos" : "Foto",
     "Modèles" : "Modelli",
     "Textes" : "Testi",
     "Fonds" : "Sfondi",
     "Stickers" : "Adesivi",

     "Chargement ..." : "Caricamento ...",

     "Luminosité" : "Luminosità",
     "Saturation" : "Saturazione",
     "Contraste" : "Contrasto",

     "couverture" : "copertina",

     "Ok" : "Ok",
     "OK" : "OK",

     "$ photos": "$ foto",

     "Vue globale" : "Panoramica",
     "Zoomer" : "Zoom",

     "Editeur" : "Editor",

     "Total" : "Totale",
     "hors livraison" : "esclusa consegna",
     
     "Trier par ordre d'ajout" : "Ordina per ordine di aggiunta",
     "Trier par date de photo" : "Ordina per data della foto",
     "Masquer les photos utilisées" : "Nascondi le foto utilizzate",

     "Ajouter un titre" : "Aggiungi un titolo",
     "Ajouter du texte" : "Aggiungi testo",
     "Modèles à personnaliser" : "Modelli personalizzabili",

     "Ajouter $ photo$" : "Aggiungi $ foto$",
     
     // popups
     "J'ai vérifié votre album, et j'ai constaté cela :" : "Ho controllato il tuo album e ho notato questo:",
      
     "Ca sera rapide ..." : "Sarà veloce ...",
     "Il semble que la connexion soit un peu lente..." : "Sembra che la connessione sia un po' lenta...",
     "La connexion doit vraiment être trop lente..." : "La connessione deve essere davvero troppo lenta...",
     "La connexion est un peu lente..." : "La connessione è un po' lenta...",
     "J'essai de nouveau..." : "Provo di nuovo...",
     "Encore quelques secondes..." : "Ancora qualche secondo...",
     "La connexion est trop lente..." : "La connessione è troppo lenta...",
     "J'insiste encore..." : "Insisto ancora...",
     "On devrait y être bientôt..." : "Dovremmo esserci presto...",
     "Je sauvegarde" : "Sto salvando",
     "Ré-essayer" : "Riprova",

     "Je sauvegarde votre oeuvre d'art" : "Sto salvando la tua opera d'arte",
  
     "La sauvegarde a échouée !" : "Il salvataggio è fallito!",
     "Veuillez ré-essayer.<br>Sinon <a href='/contact' target='_blank'>contacter le service client</a>" : "Si prega di riprovare o <a href='/contatto' target='_blank'>contattare il servizio clienti</a>.",
  
     "Je prépare votre création" : "Preparo le tue foto",
     "Ça va être génial !" : "Sarà fantastico!",

     "On va créer quelque chose de beau" : "Creeremo qualcosa di bello",
     "Je m'occupe de tout" : "Penso a tutto io",
     "Ce sera parfait !" : "Sarà perfetto!",
     "Ça arrive tout de suite" : "Arriva subito",
     "Je mets tout en place" : "Sto sistemando tutto",
     "Vous êtes entre de bonnes mains" : "Sei in buone mani",
     "Encore un petit instant..." : "Ancora un attimo...",
     "C'est bientôt prêt" : "È quasi pronto",
     "J'ouvre votre création" : "Sto aprendo la tua creazione",
     "On reprend votre création" : "Riprendiamo la tua creazione",
     "Je charge votre création" : "Sto caricando la tua creazione",
     "Vous allez pouvoir continuer" : "Potrai continuare",
     "Bon retour !" : "Di nuovo qui!",
  
     "Votre album sera bientôt accessible" : "Il tuo album sarà presto accessibile",
     "Il est en cours d'envoi vers nos imprimantes." : "È in fase di invio alle nostre stampanti.",
  
     "Revenir" : "Tornare",
     "Quel type de couverture<br>désirez-vous ?" : "Che tipo di copertina<br>desideri?",
  
     "Carnet Agrafé" : "Taccuino Graffato",
     "Album Spirale" : "Album a Spirale",
     "Album Souple" : "Album Morbido",
     "Album Rigide" : "Album Rigido",
     "Album Ouverture à plat" : "Album apertura ultrapiatta",

     "Petit carré" : "Piccolo Quadrato",
     "Grand carré" : "Grande Quadrato",
     "Petit Paysage" : "Piccolo Paesaggio",
     "Grand Paysage" : "Grande Paesaggio",
     "Petit Portrait" : "Piccolo Ritratto",
     "Grand Portrait" : "Grande Ritratto",

     "21 x 21 cm" : "21 x 21 cm",
     "30 x 30 cm" : "30 x 30 cm",
     "21 x 15 cm" : "21 x 15 cm",
     "29,7 x 21 cm" : "29,7 x 21 cm",
     "15 x 21 cm" : "15 x 21 cm",
     "21 x 29,7 cm" : "21 x 29,7 cm",

     "Votre album contient $ pages" : "Il tuo album contiene $ pagine",
     "dont $ pages additionnelles (+$ €)" : "incluso $ pagine aggiuntive (+$ €)",

     "A partir de $ €" : "A partire da $ €",
     "A partir de <strong>$€</strong>" : "A partire da <strong>$€</strong>",
  
     "Quel type d'ouverture souhaitez-vous ?" : "Che tipo di apertura desideri?",
     "Ouverture normale" : "Apertura normale",
     "Ouverture à plat" : "Apertura piatta",
     "Choisissez la forme de votre album" : "Scegli la forma del tuo album",
  
     "Retour" : "Indietro",
     "Pages" : "Pagine",
     "Nombre de photos insuffisant" : "Numero di foto insufficiente",
     "Cliquez sur Retour, et ajoutez au moins $ photo(s) pour continuer la création de votre album." : "Clicca su Indietro e aggiungi almeno $ foto per continuare la creazione del tuo album.",

     "Ajoutez des photos": "Aggiungi foto",
     "photo": "foto",

     "Fermer" : "Chiudere",
     "Sauver" : "Salvare",
     "Annuler" : "Annullare",
     "Quitter" : "Uscire",

     "Cadrer" : "Ritaglia",
     "Par défaut" : "Predefinito",

     "Etes-vous sûre ?" : "Sei sicuro?",
     "Cette photo est utilisée dans votre album.<br>Elle sera supprimée de toutes les pages ou elle apparaît." : "Questa foto è utilizzata nel tuo album.<br>Sarà rimossa da tutte le pagine in cui appare.",
     
     "Je la supprime" : "La elimino",
     "Non" : "No",
 
     "En supprimant ce thème, toutes les mises en pages liées seront supprimées définitivement, et les clients n'y auront plus accès immédiatement." : "Eliminando questo tema, tutti i layout correlati saranno rimossi definitivamente e i clienti non avranno più accesso immediato.",
     "Je le supprime" : "Lo elimino",
     
     "Votre fichier est en cours d'import..." : "Il tuo file è in fase di importazione...",
     
     "Je n'ai pas réussi à récupérer vos photos" : "Non sono riuscito a recuperare le tue foto",
     "Un problème technique est survenu. Veuillez essayer de nouveau dans quelques instants." : "Si è verificato un problema tecnico. Riprova tra qualche istante.",
     "Mémoire insuffisante" : "Memoria insufficiente",
     "Votre navigateur rencontre un problème de mémoire insuffisante. Veuillez le redémarrer pour régler le problème." : "Il tuo browser sta riscontrando un problema di memoria insufficiente. Riavvialo per risolvere il problema.",
     "Ajout de vos photos..." : "Aggiungendo le tue foto...",
     "Import de vos photos ($)" : "Importazione delle tue foto ($)",
     "Un fichier est déjà en cours d'import" : "Un file è già in fase di importazione",
     "Veuillez attendre que le premier fichier soit importé." : "Attendere che il primo file sia importato.",
     "Je n'ai pas pu convertir votre fichier" : "Non ho potuto convertire il tuo file",
     "J'ai rencontré un problème en essayant de convertir votre fichier. Veuillez ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "Ho riscontrato un problema nel tentativo di convertire il tuo file. Riprova o <a href='/contatto' target='_blank'>contatta il nostro servizio clienti</a>.",
     "Ces fichiers n'ont pu être transférées" : "Questi file non hanno potuto essere trasferiti",
     "Vérifiez votre connexion Internet (signal wifi faible, cable déconnecté, téléchargements en cours...), ou assurez-vous que votre fichier est encore accessible (fichier supprimé, ou disque externe déconnecté)." : "Verifica la tua connessione Internet (segnale Wi-Fi debole, cavo scollegato, download in corso...), o assicurati che il tuo file sia ancora accessibile (file eliminato o disco esterno scollegato).",
     
     "Plus tard" : "Più tardi",
     "Votre fichier est en cours d'import" : "Il tuo file è in fase di importazione",
     "Je vous préviens dès que votre fichier est prêt à être utilisé." : "Ti avviserò non appena il tuo file sarà pronto per l'uso.",
     "Un problème est survenu" : "Si è verificato un problema",
     "Je n'ai pas pu importer votre fichier. Veuillez ré-essayer ou contacter le <a href='/contact' target='_blank'>service client</a>." : "Non ho potuto importare il tuo file. Riprova o <a href='/contatto' target='_blank'>contatta il servizio clienti</a>.",
     "Je n'ai pas pu récupérer vos photos" : "Non sono riuscito a recuperare le tue foto",
     "Un problème problème technique est arrivé, vos photos n'ont pu être récupérées. Veuillez-ré-essayer ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "Si è verificato un problema tecnico, le tue foto non hanno potuto essere recuperate. Riprova o <a href='/contatto' target='_blank'>contatta il servizio clienti</a>.",
     "Analyse de vos photos" : "Analisi delle tue foto",
     "Recherche des moments clés" : "Ricerca dei momenti chiave",
     "Création de votre album" : "Creazione del tuo album",
     "Votre album est prêt !" : "Il tuo album è pronto!",
     "Je n'arrive pas à récupérer votre ouvrage" : "Non riesco a recuperare la sua creazione",
     "J'ai rencontré un problème en essayant de récupérer votre ouvrage. Veuillez-ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "Si è verificato un problema durante il tentativo di recuperare la sua creazione. La preghiamo di riprovare oppure <a href='/contatto' target='_blank'>contattare il nostro servizio clienti</a>",
     "Je n'ai pas pu charger les pages de votre fichier" : "Non sono riuscito a caricare le pagine del tuo file",
     "J'ai rencontré un problème en essayant de charger les pages de votre fichier. Veuillez ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "Ho riscontrato un problema nel tentativo di caricare le pagine del tuo file. Riprova o <a href='/contatto' target='_blank'>contatta il servizio clienti</a>.",
     "Je n'ai pas pu charger cette mise en page" : "Non sono riuscito a caricare questo layout",
     "J'ai rencontré un problème en essayant de charger cette mise en page. Veuillez ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "Ho riscontrato un problema nel tentativo di caricare questo layout. Riprova o <a href='/contatto' target='_blank'>contatta il servizio clienti</a>.",
 
     "Votre album a été ouvert ailleurs" : "Il tuo album è stato aperto altrove",
     "Pour éviter des problèmes de sauvegarde, veuillez garder l'album ouvert dans une page seulement." : "Per evitare problemi di salvataggio, tieni aperto l'album in una sola pagina.",
     
     "Une petite astuce ?" : "Un piccolo suggerimento?",
     "Pour sélectionner toutes les photos d'un répertoire, pressez en même temps les touches <strong>$ et A</strong>." : "Per selezionare tutte le foto di una cartella, premi contemporaneamente <strong>$ e A</strong>.",
     "Ok, c'est parti !" : "Ok, cominciamo!",
 
     "Un problème avec votre connexion Internet ?" : "Un problema con la tua connessione Internet?",
     "Notre application n'arrive pas à se connecter à nos serveurs pour sauvegarder votre travail." : "La nostra applicazione non riesce a connettersi ai nostri server per salvare il tuo lavoro.",
     "Tentative de reconnexion..." : "Tentativo di riconnessione...",
 
     "Ne perdez pas votre travail." : "Non perdere il tuo lavoro.",
     "Sauvegardez votre travail, c'est simple et gratuit!<br><br>Votre création sera conservé sans limite de temps, et vous pourrez continuer à la modifier quand vous le souhaitez." : "Salva il tuo lavoro, è semplice e gratuito!<br><br>La tua creazione sarà conservata senza limiti di tempo e potrai continuare a modificarla quando vuoi.",
 
     "Connectez-vous" : "Accedi",
     "Votre email" : "La tua email",
     "Votre mot de passe" : "La tua password",
     "Vous ne possedez pas encore de compte ?" : "Non hai ancora un account?",
     "Se connecter" : "Accedi",
     "Le format de votre email est incorrect" : "Il formato della tua email è incorretto",
     "Votre mot de passe doit contenir au moins 6 caractères" : "La tua password deve contenere almeno 6 caratteri",
     "Veuillez saisir votre email et mot de passe" : "Inserisci la tua email e password",
     "Connexion" : "Connessione",
     "Email ou mot de passe incorrect" : "Email o password errata",
     "Email déjà utilisé" : "Email già utilizzata",
     "Enregistrement" : "Registrazione",
     "Mot de passe incorrect" : "Password errata",
 
     "Bienvenue chez Flexilivre !" : "Benvenuto in Flexilivre!",
     "Créez votre album en toute tranquillité, il est sauvegardé automatiquement sur votre compte." : "Crea il tuo album con tranquillità, verrà salvato automaticamente sul tuo account.",
 
     "Sauvegarder votre ouvrage" : "Salva il tuo lavoro",
     "Entrez votre email" : "Inserisci la tua email",
     "Choisissez votre mot de passe" : "Scegli la tua password",
     "Vous possedez deja un compte?" : "Hai già un account?",
     "En poursuivant, vous acceptez lez conditions generales" : "Continuando, accetti i termini e le condizioni",
 
     "Ajout impossible" : "Impossibile aggiungere",
     "Votre album photo ne peut contenir plus de $ pages." : "Il tuo album fotografico non può contenere più di $ pagine.",
     "Suppression impossible" : "Eliminazione impossibile",
     "Votre album photo ne peut contenir moins de $ pages." : "Il tuo album fotografico non può contenere meno di $ pagine.",
     
     "Je n'arrive pas à sauvegarder votre création" : "Non riesco a salvare la tua creazione.",
     "J'ai rencontré un problème lors de la sauvegarde de votre création. Veuillez-ressayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "Si è verificato un problema durante il salvataggio della sua creazione. Per favore, riprovi oppure <a href='/contact' target='_blank'>contatti il nostro servizio clienti</a>.",
     
     "Une erreur est arrivée" : "Si è verificato un errore",
     "Nous n'avons pu joindre le serveur. Veuillez ré-essayer de nouveau, ou contacter <a href='/contact/' target='_blank'>notre service technique</a>" : "Non siamo riusciti a connetterci al server. Riprova o contatta <a href='/contatto/' target='_blank'>il nostro servizio tecnico</a>.",

     "Texte de la tranche de l'album" : "Testo del dorso dell'album",
     "Texte" : "Testo", 
     "Fond" : "Sfondo",
     "Retourner" : "Girare",
     "Tourner" : "Ruotare",
     "Supprimer" : "Eliminare",
     "Supprimer ces 2 pages" : "Elimina queste 2 pagine",

     /* theme edit */
     "Sélectionnez la thématique" : "Seleziona la tematica",
     "Choisir ces modèles" : "Scegli questi modelli",
     "Tous les modèles" : "Tutti i modelli",
     "Sélectionnez un thème" : "Seleziona un tema",
 
     "Ouverture impossible" : "Apertura impossibile",
     "L'application d'édition ne peut être ouverte que depuis notre site" : "L'applicazione di editing può essere aperta solo dal nostro sito",
     "Retourner sur Flexilivre.com" : "Ritorna su Flexilivre.com",

     // renderers
     "Photo utilisée" : "Foto utilizzata",
     "Photo sélectionnée" : "Foto selezionata",

     // social
     "Si rien ne ne se passe après avoir cliqué sur le bouton ci-dessus, veuillez autoriser votre navigateur à afficher les popups." : "Se non succede nulla dopo aver cliccato sul pulsante sopra, permetti al tuo browser di mostrare i popup.",
     "Cliquez sur le bouton ci-dessous pour vous connectez et autoriser notre application à importer vos photos." : "Clicca sul pulsante qui sotto per connetterti e autorizzare la nostra applicazione a importare le tue foto.",

     //stage
     "Cette image n'a pu être chargée" : "Questa immagine non ha potuto essere caricata",
     "Ne placez pas visages au niveau de la séparation des pages,<br>ils risquent de ne pas se recouper parfaitement après la fabrication." : "Non posizionare visi a livello della separazione delle pagine,<br>potrebbero non allinearsi perfettamente dopo la produzione.",
     "Votre photo n'est pas de qualité suffisante. Réduisez sa taille, ou remplacez-la par une meilleure photo." : "La tua foto non è di qualità sufficiente. Riduci le sue dimensioni o sostituiscila con una foto migliore.",
     "Cliquez pour personnaliser la tranche" : "Clicca per personalizzare il dorso",
     "L'ajout de texte sur la tranche n'est possible qu'avec une couverture rigide, ou avec plus de 40 pages." : "L'aggiunta di testo sul dorso è possibile solo con una copertina rigida o con più di 40 pagine.",
     "Ce bloc texte est trop proche du bord. Déplacez-le ou réduisez-le pour qu'il ne soit pas coupé lors de la fabrication." : "Questo blocco di testo è troppo vicino al bordo. Spostalo o riducilo per evitare che venga tagliato durante la produzione.",

     "Votre texte dépasse !" : "Il tuo testo supera!",
     "Votre texte est trop proche du bord de la page, il risque de ne pas être imprimé totalement." : "Il tuo testo è troppo vicino al bordo della pagina, potrebbe non essere stampato completamente.",
     "Déplacez votre texte, ou réduisez-le." : "Sposta o riduci il tuo testo.",

     "Ajouter deux pages" : "Aggiungi due pagine",
     "Chargement" : "Caricamento",
     "Modifier la couleur de fond" : "Modifica il colore dello sfondo",
     "Ajouter du texte" : "Aggiungi testo",
     "Le logo est supprimable au moment du passage de la commande.<br><br>Par contre, le QRCode n'est pas supprimable." : "Il logo può essere rimosso al momento dell'ordine.<br>Tuttavia, il QRCode non può essere rimosso.",

     // data / filters
     "Recherche" : "Ricerca",
     "Fonds utilisés" : "Sfondi utilizzati",
     "Fonds recommandés" : "Sfondi consigliati",
     "Stickers utilisés" : "Adesivi utilizzati",
     "Stickers recommandés" : "Adesivi consigliati", 
     "Aucun résultat pour" : "Nessun risultato per",
     "Pages simples" : "Pagine singole",
     "Pages doubles" : "Pagine doppie",
     "Normal" : "Normale",
     "Lumière" : "Luce",
     "Contraste" : "Contrasto",
     "Couleur +" : "Colore +",
     "Netteté" : "Nitidezza",
     "Vieilli" : "Invecchiato",
     "Noir & Blanc" : "Bianco e Nero",
     "Sepia" : "Sepia",
     "Focus" : "Focus",
     "Vintage" : "Vintage",
     "Vintage 2" : "Vintage 2",
     "Ordre d'ajout" : "Ordine di aggiunta",
     "Ordre Chronologique" : "Ordine cronologico",
     "Par visage" : "Per viso",

     // data / models
     "Cliquez pour personnaliser la tranche" : "Clicca qui per personalizzare il dorso",
     "L'ajout de texte sur la tranche n'est possible que si votre album contient au moins 40 pages" : "L'aggiunta di testo sul dorso è possibile solo se il tuo album contiene almeno 40 pagine",
     "L'ajout de texte sur la tranche n'est possible que : <ul><li>Sur une couverture rigide</li><li>Sur une couverture souple avec au moins 40 pages</li></ul>" : "L'aggiunta di testo sul dorso è possibile solo: <ul><li>Con una copertina rigida</li><li>Con una copertina morbida e almeno 40 pagine</li></ul>", 
     "Couverture Agrafée" : "Copertina Graffata",
     "Couverture Spirale" : "Copertina a Spirale",
     "Couverture Souple" : "Copertina Morbida",
     "Couverture Rigide" : "Copertina Rigida",
     "Rigide & Ouverture à plat" : "Rigida & Apertura Piana",
     "Couverture Dos" : "Copertina Posteriore",
     "Couverture Face" : "Copertina Frontale",
     "Couv." : "Cop.",
     "Couverture" : "Copertina",
     "Ajouter un texte" : "Aggiungi un testo",
     "Ajouter un TITRE" : "Aggiungi un TITOLO",
     "Page" : "Pagina",
     "page" : "pagina",

     "- La " : "- La",
     "est vide" : "è vuota",

     // data / repositories
     "Rectangle" : "Rettangolo",
     "Triangle" : "Triangolo",
     "Losange" : "Losanga",
     "Etoile" : "Stella",
     "Cercle" : "Cerchio",
     "Coeur" : "Cuore",
     "Polygone" : "Poligono",

     // --- new
     // photo renderer
     "Veuillez attendre la fin du transfer<br>pour pouvoir utiliser cette photo." : "Attendere la fine del trasferimento<br>prima di utilizzare questa foto.",
     "Intérieur de couverture<br> non imprimable" : "Interno della copertina<br> non stampabile",
     "Votre fichier a été importé !" : "Il tuo file è stato importato!",
     "Nous avons converti votre fichier en album. Veuillez vérifier qu'aucun texte important ne soit trop proche des bords. Il risquerai d'être coupé à la fabrication." : "Abbiamo convertito il tuo file in un album. Assicurati che nessun testo importante sia troppo vicino ai bordi. Potrebbe essere tagliato durante la produzione.",

     "Appliquer" : "Applica",

     "Appliquer à la page courante" : "Applica alla pagina corrente",
     "Appliquer à toutes les pages" : "Applica a tutte le pagine",
     "Vos mises en page" : "I tuoi layout",

     "Votre album ne contient pas un nombre de pages multiple de 4." : "Il tuo album non contiene un numero di pagine multiplo di 4.",
     "Par ailleurs, votre album ne contient pas un nombre de pages multiple de 4." : "Inoltre, il tuo album non contiene un numero di pagine multiplo di 4.",
     "Une feuille sera donc ajoutée à la fin de votre ouvrage au moment de la fabrication." : "Quindi verrà aggiunta un foglio alla fine del tuo lavoro durante il processo di fabbricazione.",

     "Je vérifie votre création.." : "Sto verificando il tuo creazione..",
     "C'est parti !" : "Cominciamo!",

     "Ajouter une photo" : "Aggiungi una foto",
     "Déposez votre photo ici" : "Deposita la tua foto qui",

     "Choisissez la taille de votre album" : "Scegli le dimensioni del tuo album",
     "Prix : <strong>$ €</strong>" : "Prezzo: <strong>$ €</strong>",
     "Top Vente" : "Più venduto",
     "Souhaitez-vous un format plus grand ?" : "Desideri un formato più grande?",
     "Souhaitez-vous sublimer votre album ?" : "Desideri impreziosire il tuo album?",
     "Sélectionnez la couverture de votre album" : "Seleziona la copertina del tuo album",
     "Album Rigide + Ouverture à plat" : "Album Rigido + Apertura piatta",
     "Indisponible<br>avec la couverture actuelle" : "Non disponibile<br>con la copertina attuale",
     "Non disponible à cause du nombre de pages de votre album" : "Non disponibile a causa del numero di pagine del tuo album",

     "Ajoutez vos photos" : "Aggiungi le tue foto",
     "Sélectionnez vos photos" : "Seleziona le tue foto",

     "Sélectionnez au minimum 24 photos" : "Seleziona almeno 24 foto",

     "Je peux créer votre album pour vous !" : "Posso creare il tuo album per te!",
     "Oui, c'est parti !" : "Sì, cominciamo!",
     "Je vais vous créer un magnifique album !" : "Creerò un magnifico album per te!",
     "C'est parti" : "Cominciamo",
     "Je créé votre album, ca sera rapide !" : "Sto creando il tuo album, sarà veloce!",
     "Votre album est prêt !" : "Il tuo album è pronto",

     "Retourner à votre album" : "Torna al tuo album",
     "J'analyse vos photos" : "Sto analizzando le tue foto",
     "J'analyse vos photos ($%)" : "Sto analizzando le tue foto ($%)",
     "Quel titre pour votre album ?" : "Quale titolo per il tuo album?",

     "Choisissez une proposition ou saisissez le vôtre." : "Scegli una proposta o scrivi il tuo.",

     "Le titre de votre album" : "Il titolo del tuo album",

     "Je cherche des idées de titre..." : "Cerco idee per il titolo...",

     "Créer mon album" : "Crea il mio album",

     "Le $" : "$",
     "Début $" : "Inizio $",

     "Été $" : "Estate $",

     "Fin $" : "Fine $",

     "Année $" : "Anno $",
     "Souhaitez-vous que je crée votre album photo ?" : "Vuoi che crei il tuo album fotografico?",
     "Composition intelligente" : "Composizione intelligente",
     "Je crée votre album pour vous !" : "Creo il suo album per lei!",
     "Vos photos rangées par date, posées sur des pages équilibrées. Vous n'avez plus qu'à relire." : "Le sue foto ordinate per data, disposte su pagine equilibrate. Non le resta che rileggere.",
     "Ordre chronologique respecté" : "Ordine cronologico rispettato",
     "Chaque page modifiable" : "Ogni pagina modificabile",
     "Prêt en quelques secondes" : "Pronto in pochi secondi",
     "Composer mon album" : "Comporre il mio album",
     "Non merci" : "No, grazie",
     "Le contenu de votre album va être remplacé" : "Il contenuto del suo album verrà sostituito",

     "Vos photos seront placées par ordre chronologique,<br>et vous n'aurez plus qu'à vérifier votre album." : "Le tue foto saranno disposte in ordine cronologico,<br>dovrai solo controllare il tuo album.",

     "Attention : votre contenu sera totalement remplacé." : "Attenzione: il tuo contenuto sarà completamente sostituito.",

     "Oui, Créez mon album" : "Sì, crea il mio album",

     "Non, merci" : "No, grazie",

     "Je récupère vos photos" : "Recupero le tue foto",
     "© $" : "© $",
     "du $ au $" : "dal $ al $",
     "du $ au $ $" : "dal $ al $ $",
     "Une fin d'année réunis" : "Insieme a fine anno",
     "Un week-end en images" : "Un weekend in immagini",
     "Nos bons moments" : "I nostri bei momenti",
     "Le livre de recettes" : "Il libro di ricette",
     "Nos recettes de famille" : "Le nostre ricette di famiglia",
     "Mes recettes" : "Le mie ricette",
     "Moment de famille" : "Momento in famiglia",
     "Réunion de famille" : "Riunione di famiglia",
     "Fête de famille" : "Festa di famiglia",
     "Nos compagnons" : "I nostri compagni",
     "Mon compagnon" : "Il mio compagno",
     "Mon animal" : "Il mio animale",
     "Nous deux" : "Noi due",
     "Toi et moi" : "Io e te",
     "Notre histoire" : "La nostra storia",
     "Nos premiers moments" : "I nostri primi momenti",
     "Bienvenue au monde" : "Benvenuto al mondo",
     "Notre petit ange" : "Il nostro angioletto",
     "Souvenirs de voyage" : "Ricordi di viaggio",
     "Carnet de voyage" : "Diario di viaggio",
     "Oui pour la vie" : "Sì per la vita",
     "Notre plus beau jour" : "Il nostro giorno più bello",
     "Notre Mariage" : "Il nostro matrimonio",
     "Joyeux anniversaire" : "Buon compleanno",
     "Mon anniversaire" : "Il mio compleanno",
     "Une année de plus" : "Un anno in più",
     "Notre soirée" : "La nostra serata",
     "Entre amis" : "Tra amici",
     "C'était la fête" : "Che festa",
     "Notre voyage" : "Il nostro viaggio",
     "J'affine mes propositions ..." : "Sto affinando le mie proposte ...",
     "On feuillette vos $ photos…" : "Sto sfogliando le tue $ foto…",
     "On repère les moments forts…" : "Cerco i momenti migliori…",
     "On imagine 3 titres…" : "Immagino 3 titoli…",
     "C'est plus long que prévu, on y est presque…" : "Ci vuole più del previsto, ci siamo quasi…",
     "Un instant, je place vos photos..." : "Un attimo, sto disponendo le tue foto...",
     "Week-end à $" : "Weekend a $",

     "Un saut à $" : "Una scappata a $",

     "Escapade à $" : "Fuga a $",

     "Une journée à $" : "Una giornata a $",

     "Une semaine à $" : "Una settimana a $",

     "À la découverte de $" : "Alla scoperta di $",

     "Nos vacances à $" : "Le nostre vacanze a $",

     "Un voyage à $" : "Un viaggio a $",

     "Les vacances de Noël à $" : "Le vacanze di Natale a $",

     "La fin d'année à $" : "Fine anno a $",

     "Un été à $" : "Un'estate a $",

     "Notre week-end : $" : "Il nostro weekend: $",

     "Nos vacances : $" : "Le nostre vacanze: $",

     "Souvenirs : $" : "Ricordi: $",

     "Découverte : $" : "Scoperta: $",

     "Noël : $" : "Natale: $",

     "Les fêtes : $" : "Le feste: $",

     "Un été : $" : "Un'estate: $",

     "Noël $" : "Natale $",

     "Les fêtes de fin d'année" : "Le feste di fine anno",

     "Notre week-end" : "Il nostro weekend",

     "Un week-end en famille" : "Un weekend in famiglia",

     "Nos vacances" : "Le nostre vacanze",

     "Souvenirs de vacances" : "Ricordi di vacanza",

     "L'été $" : "L'estate $",

     "Nos souvenirs de $" : "I nostri ricordi di $",

     "Nos plus beaux moments" : "I nostri momenti più belli",
    "Un mobile" : "Un cellulare",
    "Votre ordinateur" : "Il tuo computer",
    "Réseaux sociaux" : "Social network",
    "Autre" : "Altro",     
     "Facebook" : "Facebook",
     "Instagram" : "Instagram",
     "Google" : "Google",
     "Fichier PDF" : "File PDF",
     "Vos Albums" : "I tuoi Album",

     "Connecté à Google Photos sur " : "Connesso a Google Foto su",
     "Se déconnecter" : "Disconnettersi",

      //  edition
      "Zoom -" : "Zoom -",
      "Zoom +" : "Zoom +",
      "Rotation" : "Rotazione",
      "Bord" : "Bordo",
      "Forme" : "Forma",
      "Effet" : "Effetto",
      "Descendre" : "Abbassare",
      "Remonter" : "Alzare",
      
      "Inverser" : "Invertire",
      "Gras" : "Grassetto",
      "Italic" : "Corsivo",
      "Fond" : "Sfondo",
      "Gauche" : "Sinistra",
      "Centre" : "Centro",
      "Droite" : "Destra",

      "Changez la couverture ou la taille votre album" : "Cambia la copertina o le dimensioni del tuo album",
      "J'ai compris" : "Ho capito",

      "Le format de fichier que vous avez sélectionné est incorrect." : "Il formato del file che hai selezionato è incorretto.",
      "Veuillez choisir un fichier avec une extension valide (.pdf)" : "Si prega di scegliere un file con un'estensione valida (.pdf)",

     "De $ à $ pages" : "Da $ a $ pagine",
     "Album $, $" : "Album $, $",
     "Pages" : "Pagine",
     "A partir de $" : "A partire da $",
     
     "Refaire" : "Rifare",
    
     "Ajouter des photos" : "Aggiungi foto",
     "Veuillez ajouter au moins $ photos" : "Almeno $ foto",
     "Trier / filtrer vos photos" : "Ordina / filtra le tue foto",

     "Vous devez avoir au moins <span class='numPhotosLabel'>$ photos</span> pour commander vos tirages" : "Devi avere almeno <span class='numPhotosLabel'>$ foto</span> per ordinare le tue stampe",
     "Vous devez avoir moins de <span class='numPhotosLabel'>$ photos</span> pour commander vos tirages" : "Devi avere meno di <span class='numPhotosLabel'>$ foto</span> per ordinare le tue stampe",

     "Vous devez avoir au moins <span class='numPhotosLabel'>$ photos</span> pour commander votre album" : "Devi avere almeno <span class='numPhotosLabel'>$ foto</span> per ordinare il tuo album",
     "Vous devez avoir moins de <span class='numPhotosLabel'>$ photos</span> pour commander votre album" : "Devi avere meno di <span class='numPhotosLabel'>$ foto</span> per ordinare il tuo album",

     "Ajoutez des photos puis cliquez ici pour les placer automatiquement" : "Aggiungi foto e poi clicca qui per posizionarle automaticamente",
    
     "Cliquez pour changer la taille ou la couverture" : "Clicca per cambiare le dimensioni o la copertina",
     "Cliquez pour changer la taille de votre cadre": "Clicca per cambiare le dimensioni della tua cornice",
     "Cliquez pour changer la taille de votre affiche": "Clicca per cambiare le dimensioni del tuo poster",
     "Cliquez pour changer la taille" : "Clicca per cambiare la dimensione",

     "contient une zone photo vide" : "contiene un'area foto vuota",
     "contient $ zones photo vides" : "contiene $ aree foto vuote",

     "Transparence" : "Trasparenza",

     "Vous devez ajouter au moins 24 photos" : "Devi aggiungere almeno 24 foto",

     "Quel type d'album souhaitez-vous créer ?" : "Che tipo di album vuoi creare?",
     "Choisissez le thème de votre album" : "Scegli il tema del tuo album",
     "Type d'album" : "Tipo di album",

     "Budget" : "Budget",
     "Thèmes" : "Temi",
     "Votre Album" : "Il Tuo Album",

     "Cliquez ici pour agrandir" : "Clicca qui per ingrandire",

       //----
    "Bienvenue dans votre album" : "Benvenuto nel tuo album",
    
    "Voici quelques informations rapides<br>avant de commencer" : "Ecco alcune informazioni rapide<br>prima di iniziare",
    "L'effet 3D sera appliqué lors de l'impression de votre album.<br><br>2 paires de lunettes 3D<br>seront incluses dans votre colis.<br><br><span class='blue bold'>Vous ne verrez pas l'effet 3D dans l'éditeur</span>" : "L'effetto 3D sarà applicato durante la stampa del tuo album.<br><br>2 paia di occhiali 3D<br>saranno inclusi nel tuo pacco.<br><br><span class='blue bold'>Non vedrai l'effetto 3D nell'editor</span>",
    "L'effet 3D sera appliqué lors de<br>l'impression de votre album.<br><br>2 paires de lunettes 3D<br>seront incluses dans votre colis.<br><br><span class='blue bold'>Vous ne verrez pas<br>l'effet 3D dans l'éditeur</span>" : "L'effetto 3D sarà applicato durante<br>la stampa del tuo album.<br><br>2 paia di occhiali 3D<br>saranno inclusi nel tuo pacco.<br><br><span class='blue bold'>Non vedrai<br>l'effetto 3D nell'editor</span>",
    "Choisissez bien vos photos, pour un <span class='green'>effet optimal</span>" : "Scegli bene le tue foto, per un <span class='green'>effetto ottimale</span>.",
    "Choisissez bien vos photos<br>pour un <span class='green'>effet optimal</span>" : "Scegli attentamente le tue foto<br>per un <span class='green'>effetto ottimale</span>.",
    "Arrière plan avec de la matière<br>et une profondeur raisonnable" : "Sfondo con materiale<br>e profondità ragionevole",
    "Sujet au<br>premier plan" : "Soggetto in<br>primo piano",
    "de 1 à 4<br>personnes max" : "da 1 a 4<br>persone max",

    "Vue page" : "Vista pagina",

    "Coller" : "Incollare",

    "Album Blanc" : "Album Bianco",

    "Marge de découpe" : "Margine di taglio",

    "Votre album est sauvegardé !" : "Il tuo album è stato salvato!",
    "A partir de maintenant, votre album est sauvegardé automatiquement." : "Da ora in poi, il tuo album sarà salvato automaticamente.",

    "Comment faire ?" : "Come fare?",
    "Entrez votre numéro de téléphone portable. Vous recevrez un sms avec le lien de l'application. Vous pourrez alors envoyer vos photos vers votre albums." :  "Inserisci il tuo numero di cellulare. Riceverai un SMS con il link all'applicazione. Poi potrai inviare le tue foto al tuo album.",
    "Téléphone" : "Telefono",
    "numéro invalide": "numero non valido",
    "C'est parti !" : "Andiamo!",
    "plus rapide" :  "Più veloce",
    "Scannez ce QRcode pour récupérer les photos depuis votre mobile" :  "Scansiona questo QR code per recuperare le foto dal tuo cellulare.",

  // Ajout de pages

  "Vierges": "Vuote",
  "Thématiques": "Tematiche",
  "Ajouter des pages": "Aggiungi pagine",
  "jusqu'à $ pages ($€ par pages)": "fino a $ pagine ($€ per pagina)",
  "$ pages": "$ pagine",
  "Vous avez atteint le nombre maximum de pages": "Hai raggiunto il numero massimo di pagine",

  // Countries
    "Afghanistan": "Afghanistan",
    "Albanie": "Albania",
    "Algérie": "Algeria",
    "Samoa Américaines": "Samoa Americane",
    "Andorre": "Andorra",
    "Angola": "Angola",
    "Anguilla": "Anguilla",
    "Antarctique": "Antartide",
    "Antigua-et-Barbuda": "Antigua e Barbuda",
    "Argentine": "Argentina",
    "Arménie": "Armenia",
    "Aruba": "Aruba",
    "Australie": "Australia",
    "Autriche": "Austria",
    "Azerbaïdjan": "Azerbaijan",
    "Bahamas": "Bahamas",
    "Bahreïn": "Bahrein",
    "Bangladesh": "Bangladesh",
    "Barbade": "Barbados",
    "Bélarus": "Bielorussia",
    "Belgique": "Belgio",
    "Belize": "Belize",
    "Bénin": "Benin",
    "Bermudes": "Bermuda",
    "Bhoutan": "Bhutan",
    "Bolivie": "Bolivia",
    "Bosnie-Herzégovine": "Bosnia ed Erzegovina",
    "Botswana": "Botswana",
    "Île Bouvet": "Isola Bouvet",
    "Brésil": "Brasile",
    "Territoire britannique de l'océan Indien": "Territorio britannico dell'Oceano Indiano",
    "Îles Vierges britanniques": "Isole Vergini britanniche",
    "Brunei Darussalam": "Brunei Darussalam",
    "Bulgarie": "Bulgaria",
    "Burkina Faso": "Burkina Faso",
    "Burundi": "Burundi",
    "Cambodge": "Cambogia",
    "Cameroun": "Camerun",
    "Canada": "Canada",
    "Cap-Vert": "Capo Verde",
    "Îles Caïmans": "Isole Cayman",
    "République centrafricaine": "Repubblica Centrafricana",
    "Tchad": "Ciad",
    "Chili": "Cile",
    "Chine": "Cina",
    "Île Christmas": "Isola Christmas",
    "Îles Cocos (Keeling)": "Isole Cocos (Keeling)",
    "Colombie": "Colombia",
    "Comores": "Comore",
    "Congo": "Congo",
    "République démocratique du Congo": "Repubblica Democratica del Congo",
    "Îles Cook": "Isole Cook",
    "Costa Rica": "Costa Rica",
    "Croatie": "Croazia",
    "Cuba": "Cuba",
    "Chypre": "Cipro",
    "République tchèque": "Repubblica Ceca",
    "Danemark": "Danimarca",
    "Djibouti": "Gibuti",
    "Dominique": "Dominica",
    "République dominicaine": "Repubblica Dominicana",
    "Équateur": "Ecuador",
    "Égypte": "Egitto",
    "Salvador": "El Salvador",
    "Guinée équatoriale": "Guinea Equatoriale",
    "Érythrée": "Eritrea",
    "Estonie": "Estonia",
    "Éthiopie": "Etiopia",
    "Îles Malouines": "Isole Falkland",
    "Îles Féroé": "Isole Faroe",
    "Fidji": "Figi",
    "Finlande": "Finlandia",
    "France": "Francia",
    "Guyane française": "Guyana francese",
    "Polynésie française": "Polinesia francese",
    "Terres australes françaises": "Territori australi francesi",
    "Gabon": "Gabon",
    "Gambie": "Gambia",
    "Géorgie": "Georgia",
    "Allemagne": "Germania",
    "Ghana": "Ghana",
    "Gibraltar": "Gibilterra",
    "Grèce": "Grecia",
    "Groenland": "Groenlandia",
    "Grenade": "Grenada",
    "Guadeloupe": "Guadalupa",
    "Guam": "Guam",
    "Guatemala": "Guatemala",
    "Guernesey": "Guernsey",
    "Guinée": "Guinea",
    "Guinée-Bissau": "Guinea-Bissau",
    "Guyane": "Guyana",
    "Haïti": "Haiti",
    "Îles Heard-et-MacDonald": "Isole Heard e McDonald",
    "Saint-Siège (État de la Cité du Vatican)": "Santa Sede (Stato della Città del Vaticano)",
    "Honduras": "Honduras",
    "Hong Kong": "Hong Kong",
    "Hongrie": "Ungheria",
    "Islande": "Islanda",
    "Inde": "India",
    "Indonésie": "Indonesia",
    "Iran": "Iran",
    "Iraq": "Iraq",
    "Irlande": "Irlanda",
    "Île de Man": "Isola di Man",
    "Israël": "Israele",
    "Italie": "Italia",
    "Jamaïque": "Giamaica",
    "Japon": "Giappone",
    "Jersey": "Jersey",
    "Jordanie": "Giordania",
    "Kazakhstan": "Kazakistan",
    "Kenya": "Kenya",
    "Kiribati": "Kiribati",
    "Corée du Nord": "Corea del Nord",
    "Corée du Sud": "Corea del Sud",
    "Koweït": "Kuwait",
    "Kirghizistan": "Kirghizistan",
    "Laos": "Laos",
    "Lettonie": "Lettonia",
    "Liban": "Libano",
    "Lesotho": "Lesotho",
    "Libéria": "Liberia",
    "Libye": "Libia",
    "Liechtenstein": "Liechtenstein",
    "Lituanie": "Lituania",
    "Luxembourg": "Lussemburgo",
    "Macao": "Macao",
    "Macédoine du Nord": "Macedonia del Nord",
    "Madagascar": "Madagascar",
    "Malawi": "Malawi",
    "Malaisie": "Malesia",
    "Maldives": "Maldive",
    "Mali": "Mali",
    "Malte": "Malta",
    "Îles Marshall": "Isole Marshall",
    "Martinique": "Martinica",
    "Mauritanie": "Mauritania",
    "Maurice": "Mauritius",
    "Mayotte": "Mayotte",
    "Mexique": "Messico",
    "Micronésie": "Micronesia",
    "Moldavie": "Moldavia",
    "Monaco": "Monaco",
    "Mongolie": "Mongolia",
    "Monténégro": "Montenegro",
    "Montserrat": "Montserrat",
    "Maroc": "Marocco",
    "Mozambique": "Mozambico",
    "Myanmar": "Myanmar",
    "Namibie": "Namibia",
    "Nauru": "Nauru",
    "Népal": "Nepal",
    "Pays-Bas": "Paesi Bassi",
    "Nouvelle-Calédonie": "Nuova Caledonia",
    "Nouvelle-Zélande": "Nuova Zelanda",
    "Nicaragua": "Nicaragua",
    "Niger": "Niger",
    "Nigeria": "Nigeria",
    "Niue": "Niue",
    "Île Norfolk": "Isola Norfolk",
    "Îles Mariannes du Nord": "Isole Marianne Settentrionali",
    "Norvège": "Norvegia",
    "Oman": "Oman",
    "Pakistan": "Pakistan",
    "Palaos": "Palau",
    "Palestine": "Palestina",
    "Panama": "Panama",
    "Papouasie-Nouvelle-Guinée": "Papua Nuova Guinea",
    "Paraguay": "Paraguay",
    "Pérou": "Perù",
    "Philippines": "Filippine",
    "Îles Pitcairn": "Isole Pitcairn",
    "Pologne": "Polonia",
    "Portugal": "Portogallo",
    "Porto Rico": "Porto Rico",
    "Qatar": "Qatar",
    "Réunion": "Riunione",
    "Roumanie": "Romania",
    "Russie": "Russia",
    "Rwanda": "Ruanda",
    "Saint-Barthélemy": "Saint Barthélemy",
    "Sainte-Hélène, Ascension et Tristan da Cunha": "Sant'Elena, Ascensione e Tristan da Cunha",
    "Saint-Christophe-et-Niévès": "Saint Kitts e Nevis",
    "Sainte-Lucie": "Santa Lucia",
    "Saint-Martin (partie française)": "Saint Martin (parte francese)",
    "Saint-Pierre-et-Miquelon": "Saint Pierre e Miquelon",
    "Saint-Vincent-et-les-Grenadines": "Saint Vincent e Grenadine",
    "Samoa": "Samoa",
    "Saint-Marin": "San Marino",
    "Sao Tomé-et-Principe": "Sao Tomé e Príncipe",
    "Arabie saoudite": "Arabia Saudita",
    "Sénégal": "Senegal",
    "Serbie": "Serbia",
    "Seychelles": "Seychelles",
    "Sierra Leone": "Sierra Leone",
    "Singapour": "Singapore",
    "Saint-Martin (partie néerlandaise)": "Sint Maarten (parte olandese)",
    "Slovaquie": "Slovacchia",
    "Slovénie": "Slovenia",
    "Îles Salomon": "Isole Salomone",
    "Somalie": "Somalia",
    "Afrique du Sud": "Sudafrica",
    "Géorgie du Sud-et-les Îles Sandwich du Sud": "Georgia del Sud e Isole Sandwich Australi",
    "Soudan du Sud": "Sud Sudan",
    "Espagne": "Spagna",
    "Sri Lanka": "Sri Lanka",
    "Soudan": "Sudan",
    "Suriname": "Suriname",
    "Svalbard et Île Jan Mayen": "Svalbard e Jan Mayen",
    "Eswatini": "Eswatini",
    "Suède": "Svezia",
    "Suisse": "Svizzera",
    "Syrie": "Siria",
    "Taïwan": "Taiwan",
    "Tadjikistan": "Tagikistan",
    "Tanzanie": "Tanzania",
    "Thaïlande": "Thailandia",
    "Timor oriental": "Timor Est",
    "Togo": "Togo",
    "Tokelau": "Tokelau",
    "Tonga": "Tonga",
    "Trinité-et-Tobago": "Trinidad e Tobago",
    "Tunisie": "Tunisia",
    "Turquie": "Turchia",
    "Turkménistan": "Turkmenistan",
    "Îles Turques-et-Caïques": "Isole Turks e Caicos",
    "Tuvalu": "Tuvalu",
    "Ouganda": "Uganda",
    "Ukraine": "Ucraina",
    "Émirats arabes unis": "Emirati Arabi Uniti",
    "Royaume-Uni": "Regno Unito",
    "États-Unis": "Stati Uniti",
    "Îles mineures éloignées des États-Unis": "Isole minori esterne degli Stati Uniti",
    "Uruguay": "Uruguay",
    "Ouzbékistan": "Uzbekistan",
    "Vanuatu": "Vanuatu",
    "Venezuela": "Venezuela",
    "Viêt Nam": "Vietnam",
    "Îles Vierges britanniques": "Isole Vergini britanniche",
    "Îles Vierges des États-Unis": "Isole Vergini americane",
    "Wallis-et-Futuna": "Wallis e Futuna",
    "Sahara occidental": "Sahara occidentale",
    "Yémen": "Yemen",
    "Zambie": "Zambia",
    "Zimbabwe": "Zimbabwe",

    "Vous allez recevoir un sms !" : "Riceverai un SMS!",
    "Dans quelques instants, vous recevrez un sms. Cliquez sur le lien, et envoyez vos photos." : "Fra pochi istanti riceverai un SMS. Clicca sul link e invia le tue foto.",

    "Changer de Thématique" : "Cambia tema",

    "Couvertures pour votre album" : "Copertine per il tuo album",
    "Modèles pour vos pages" : "Modelli per le tue pagine",

    "Thème" : "Tema",
    "Taille" : "Dimensioni",
    "Finition" : "Finitura",

    "Un Instant ..." : "Un momento...",
    "C'est presque bon !" : "È quasi pronto!",
    "Je sélectionne les meilleures photos" : "Seleziono le migliori foto",
    "Je créé votre histoire ..." : "Creo la tua storia...",

    "Mise en page aléatoire" : "Impaginazione casuale",
    "<b>$</b> vous a envoyé" : "<b>$</b> ti ha inviato",
    "Refuser" : "Rifiuta",
    "Voir les photos" : "Vedi le foto",
    "Vous allez perdre les photos partagées de $." : "Perderai le foto condivise da $.",
    "Êtes vous sûr de vouloir quitter?" : "Sei sicuro di voler uscire?",
    "Vous allez perdre les photos partagées de $. Êtes vous sûr de vouloir quitter?" : "Perderai le foto condivise da $. Sei sicuro di voler uscire?",
    "Sélectionnez les photos que vous souhaitez garder" : "Seleziona le foto che desideri conservare",
    "Tout sélectionner ($)" : "Seleziona tutto ($)",
    "Vous pouvez sélectionner $ photos maximum." : "Puoi selezionare al massimo $ foto.",
    "Tout déselectionner ($)" : "Deseleziona tutto ($)",
    "Valider ($)" : "Conferma ($)",
    "Importer ($)" : "Importa ($)",
    "Choisissez vos photos dans la fenêtre Google. Elles arriveront ici.": "Scegli le tue foto nella finestra di Google. Arriveranno qui.",
    "Vos photos" : "Le tue foto",
    "$ photos reçues" : "$ foto ricevute",
    "$ sur $ photos reçues" : "$ di $ foto ricevute",
    "Vos photos arrivent" : "Le tue foto stanno arrivando",
    "Envoyez vos photos depuis votre mobile" : "Invia le tue foto dal tuo cellulare",
    "Ouvrez le lien reçu par SMS et choisissez vos photos." : "Apri il link ricevuto via SMS e scegli le tue foto.",
    "En attente du téléphone" : "In attesa del telefono",
    "Nous attendons vos photos…" : "Attendiamo le tue foto…",
    "Gardez cette page ouverte. Les photos apparaîtront ici dès leur arrivée." : "Tieni aperta questa pagina. Le tue foto appariranno qui man mano che arrivano.",
    "Aucune photo reçue" : "Nessuna foto ricevuta",
    "Continuez l'envoi depuis votre mobile, la liste se met à jour toute seule." : "Continua a inviare dal tuo cellulare, l'elenco si aggiorna da solo.",
    "Réception en cours" : "Ricezione in corso",
    "Vos photos sont prêtes" : "Le tue foto sono pronte",
    "Importez-les dans votre album pour commencer la mise en page." : "Importale nel tuo album per iniziare l'impaginazione.",
    "$ photos seront ajoutées à votre album" : "$ foto verranno aggiunte al tuo album",
    "Envoi pas encore terminé" : "Caricamento non ancora terminato",
    "Vos photos arrivent encore depuis votre mobile. Importer seulement les $ photos déjà reçues ?" : "Le tue foto stanno ancora arrivando dal tuo cellulare. Importare solo le $ già ricevute?",
    "Importer $ photos" : "Importa $ foto",
    "Continuer l'attente" : "Continua ad aspettare",


    // Google Photos import (SelectPhotosPanel)
    "Importez-les pour les ajouter à votre création." : "Importale per aggiungerle alla tua creazione.",
    "$ photos seront importées" : "$ foto verranno importate",
    "Aucune photo n'a été reçue." : "Non è stata ricevuta alcuna foto.",
    "Aucune photo n'a pu être récupérée." : "Non è stato possibile recuperare alcuna foto.",
    "Récupération de vos photos Google" : "Recupero delle tue foto di Google",
    "Nous les récupérons depuis Google Photos, cela peut prendre un moment." : "Le stiamo recuperando da Google Foto, può richiedere qualche istante.",
    "Connexion à Google Photos" : "Connessione a Google Foto",
    "Nous récupérons vos photos…" : "Recupero delle tue foto…",
    "Elles sont récupérées depuis Google Photos, la liste se met à jour toute seule." : "Vengono recuperate da Google Foto, l'elenco si aggiorna da solo.",
    "Récupération en cours" : "Recupero in corso",
    "Récupération pas encore terminée" : "Recupero non ancora terminato",
    "La récupération des photos depuis Google n'est pas terminée. Souhaitez-vous importer seulement les $ photos affichées ?" : "Le tue foto sono ancora in fase di recupero da Google. Importare solo le $ mostrate?",

    "Récupération des photos" : "Recupero foto",


    "Appuyez ici pour tourner les pages":"Premi qui per girare le pagine",
    "Au cas ou...":"Nel caso in cui...",
    "Vous pouvez annulez vos<br>modifications ici":"Puoi annullare le tue<br>modifiche qui",
    "On Commence ?":"Iniziamo ?",
    //"Choisissez la couverture<br>de votre album":"Scegli la copertina<br>del tuo album",
    "Commencez par sélectionner vos photos !" : "Inizia selezionando le tue foto!",
    "Personne":"Persona",
    "Trier par personne":"Ordina per persona",
    "Sélectionnez vos photos depuis :":"Seleziona le tue foto da :",
    "Ajouter 2 pages":"Aggiungi 2 pagine",
    "Couvertures":"Copertine",
    "Texte de la tranche":"Testo del dorso",
    "Besoin de Recadrer ?":"Hai bisogno di ritagliare ?",
    "Appuyez une seconde fois<br>sur la photo.":"Premi una seconda volta<br>sulla foto.",
    "Classique":"Classico",
    "Mises en page":"Layout",
    "Images":"Immagini",
    "Toutes":"Tutte",
    "Non Utilisées":"Non utilizzate",
    "Remplacer":"Sostituisci",
    "Effets":"Effetti",
    "Valider":"Conferma",
    "Zoomer/Recadrez":"Zoom/Ritaglia",
    "Supprimer 2 pages":"Eliminare 2 pagine",
    'Vos Creations' : 'Le Tue Creazioni',

    "Corriger" : "Correggere",

    "Nombre de photos insuffisant" : "Numero insufficiente di foto",
    "Veuillez sélectionner au minimum 24 photos." : "Seleziona almeno 24 foto, per favore.",

    "Importez vos photos en cliquant sur le bouton ici." : "Importa le tue foto cliccando sul pulsante qui.",
    "Ajoutez une photo" : "Aggiungi una foto",
    "Appuyez sur une photo ou faîtes-la glisser vers votre page" : "Tocca una foto o trascinala sulla tua pagina",

    "Quel type d'album souhaitez-vous créer?" : "Che tipo di album desidera creare?", 

    "Tirage $" : "Stampe foto $",
    "$/$ photos" : "$/$ fotos",
    "$ photos" : "$ fotos",

    "Nombre de photo maximum" : "Numero massimo di foto",
    "Vous avez atteint le nombre maximum de photos" : "Hai raggiunto il numero massimo di foto",

    "Choisissez la taille de votre cadre" : "Scegli la dimensione della tua cornice",

    "Passer": "Salta",

    "Cadre Photo" : "Cornice fotografica",
    "Poster Photo" : "Poster Foto",

    "Ajoutez vos photos<br>en cliquant ici" : "Aggiungi le tue foto<br>cliccando qui",

    "Choisissez les photos<br>à ajouter à votre cadre" : "Scegli le foto<br>da aggiungere alla tua cornice",

    "Votre album n'a pas été sauvegardé. Etes-vous sûre de vouloir quitter cette page ?" : "Il tuo album non è stato salvato. Sei sicura di voler lasciare questa pagina?",
    "ATTENTION : en quittant sans sauvegarder vous risquez de perdre un partie de votre travail. Veuillez utiliser le bouton QUITTER pour quitter en sauvegardant votre travail." : "ATTENZIONE: Uscendo senza salvare, potresti perdere parte del tuo lavoro. Usa il pulsante ESCI per salvare e uscire.",
    
    "Aller au panier (+ $ €)": "Vai al carrello (+ $ €)",
    "Continuer sans cadre" : "Continuare senza cornice",
    "Continuer sans box" : "Continuare senza scatola",

    "Et si on rajoutait un joli papier en plus ?": "Che ne dici di aggiungere una bella carta?",
    "Et pourquoi pas une box pour ranger vos photos ?": "Perché non una scatola per conservare le tue foto?",
    "Pourquoi pas un cadre autour de votre chef d'oeuvre ?": "Che ne dici di una cornice per il tuo capolavoro?",

    "Pour photos 10 x 10cm" : "Per foto 10 x 10 cm",
    "Pour photos 15 x 10cm" : "Per foto 15 x 10 cm",

    "Calendrier Bureau" : "Calendario da Scrivania",
    "Calendrier Mural" : "Calendario da Parete",

    "Ajoutez vos photos, puis déplacez-les sur vos pages": "Aggiungi le tue foto, poi spostale sulle tue pagine",
    "Choisissez le mois de démarrage de votre calendrier": "Scegli il mese di inizio del tuo calendario",
    "Commencer": "Inizia",
    "Janvier": "Gennaio",
    "Février": "Febbraio",
    "Mars": "Marzo",
    "Avril": "Aprile",
    "Mai": "Maggio",
    "Juin": "Giugno",
    "Juillet": "Luglio",
    "Août": "Agosto",
    "Septembre": "Settembre",
    "Octobre": "Ottobre",
    "Novembre": "Novembre",
    "Décembre": "Dicembre",
    "Modifiez votre évènement": "Modifica il tuo evento",
    "Vos dates": "Le tue date",
    "Vos dates préférées méritent une place ici : anniversaires, voyages, bons moments !": "Le tue date preferite meritano un posto qui: compleanni, viaggi, bei momenti!",
    "Ajoutez un événement en sélectionnant une date dans le calendrier." : "Aggiungi un evento selezionando una data nel calendario.",
    "Ajoutez une date": "Aggiungi una data",
    "Sélectionnez la date": "Seleziona la data",
    "Entrez votre évènement": "Inserisci il tuo evento",
    "Modifiez votre évènement": "Modifica il tuo evento",

    "Lundi": "Lunedì",
    "Mardi": "Martedì",
    "Mercredi": "Mercoledì",
    "Jeudi": "Giovedì",
    "Vendredi": "Venerdì",
    "Samedi": "Sabato",
    "Dimanche": "Domenica",

    "Cliquer pour ajouter une photo" : "Clicca per aggiungere una foto",
    "Ajouter vos photos ici" : "Aggiungi le tue foto qui",
    "Choisissez votre modèle<br>Puis ajouter vos photos" : "Scegli il tuo modello<br>Poi aggiungi le tue foto",

    "Votre photo n'a pu être transformée, veuillez re-éssayer dans quelques instants." : "La sua foto non è stata trasformata, per favore riprovi tra qualche istante.",

    "Super photo, félicitations !" : "Ottima foto, congratulazioni!",
    "Un peu de magie..." : "Un pizzico di magia...",
    "Je crée votre poster..." : "Sto creando il tuo poster...",
    "On y est presque..." : "Ci siamo quasi...",
    "C'est prêt !" : "È pronto!",

    "De préférence une photo de portrait avec des visages visibles" : "Preferibilmente una foto di ritratto con volti visibili",

    "$ photos minimum" : "$ foto minimo",
    "Tirage Photo" : "Stampa fotografica",
    "Recadrez votre photo si besoin" : "Ritaglia la tua foto se necessario",
    "Choisissez la finition de votre poster" : "Scegli la finitura del tuo poster",
    "A partir de" : "A partire da",

    "Choisissez la taille de votre poster" : "Scegli la dimensione del tuo poster",
    "Changer" : "Cambiare",

    "Cliquez pour changer la finition" : "Clicca per cambiare la finitura",
    "On vous propose 4 finitions" : "Ti proponiamo 4 finiture",
    "Pour la taille, on part sur quoi ?" : "Quale dimensione preferisci?",
    "Souhaitez-vous un cadre ?" : "Desideri una cornice?",
    "A partir de" : "A partire da",

    "C'est parfait !" : "È perfetto!",
    "Nous attendons la réception de vos photos pour continuer.<br/> Vous serez redirigé automatiquement." : "Stiamo aspettando di ricevere le tue foto per continuare.<br/> Verrai reindirizzato automaticamente.",

    // poster / calendar
    "Modèles pour votre affiche" : "Modelli per il tuo poster",
    "Événements" : "Eventi",
    "Appuyez 2 fois sur la photo" : "Premi due volte sulla foto",
    "Recadrez ?" : "Ritagliare ?",

    "$ photos n'ont pu être envoyées" : "Non è stato possibile inviare $ foto",
    "1 photo n'a pu être envoyée" : "Non è stato possibile inviare 1 foto",
    "L'envoi n'était pas terminé quand la page a été fermée, j'ai donc retiré les tirages concernés. Ajoutez à nouveau vos photos, et gardez cette page ouverte jusqu'à la fin de l'envoi." : "L'invio non era terminato quando la pagina è stata chiusa, quindi ho rimosso le stampe interessate. Aggiungi di nuovo le tue foto e tieni aperta questa pagina fino alla fine dell'invio.",
    "Envoi $ %" : "Invio $ %",

    // gomme magique (shared.popups.MagicEraserPopup)
    "Gomme magique" : "Gomma magica",
    "Gommer" : "Cancella",
    "Gommer un élément" : "Cancella un elemento",
    "Comment ça marche ?" : "Come funziona?",
    "Tout effacer" : "Cancella tutto",
    "Gommer la zone" : "Cancella la zona",
    "Gommage…" : "Cancellazione…",
    "Entourez la zone à gommer : tracez un contour fermé autour de l'élément" : "Cerchi la zona da cancellare: tracci un contorno chiuso intorno all'elemento",
    "L'intérieur du contour sera gommé. Vous pouvez entourer une autre zone." : "L'interno del contorno verrà cancellato. Può cerchiare un'altra zona.",
    "Ne fermez pas la fenêtre, c'est presque fini." : "Non chiuda la finestra, è quasi finito.",
    "Voici le résultat. Gardez-le, ou recommencez" : "Ecco il risultato. Lo tenga, o ricominci",
    "Entourez un élément pour le supprimer de votre photo." : "Cerchi un elemento per eliminarlo dalla sua foto.",
    "Recommencer" : "Ricomincia",
    "Garder" : "Conserva",
    "Avant" : "Prima",
    "Après" : "Dopo",
    "Veuillez vous reconnecter." : "Effettua di nuovo l'accesso.",
    "Cette photo n'est pas accessible." : "Questa foto non è disponibile.",
    "La gomme magique est momentanément indisponible." : "La gomma magica è momentaneamente non disponibile.",
    "Cette version de la photo ne peut pas être retouchée." : "Questa versione della foto non può essere ritoccata.",
    "Le tracé n'a pas pu être lu, veuillez réessayer." : "Il tratto non è stato letto, riprova.",
    "Veuillez patienter une minute avant le prochain effacement." : "Attendi un minuto prima della prossima cancellazione.",
    "Vous avez atteint la limite d'effacements pour aujourd'hui." : "Hai raggiunto il limite di cancellazioni di oggi.",
    "Le traitement prend trop de temps, veuillez réessayer." : "L'elaborazione richiede troppo tempo, riprova.",
    "L'effacement a échoué, veuillez réessayer." : "La cancellazione non è riuscita, riprova.",

    // posters : Aperçu 3D (shared.popups.WallPreviewPopup)
    "Aperçu 3D" : "Anteprima 3D",
    "Voir votre poster sur un mur" : "Guarda il tuo poster su una parete",
    "Poster seul" : "Solo poster",
    "Poster" : "Poster",
    "Cadre bois" : "Cornice in legno",
    "Bois" : "Legno",
    "Cadre noir" : "Cornice nera",
    "Noir" : "Nera",
    "Cadre blanc" : "Cornice bianca",
    "Blanc" : "Bianca",
    "Salon" : "Soggiorno",
    "Chambre" : "Camera da letto",
    "Cuisine" : "Cucina",
    "Salon avec canapé rose" : "Soggiorno con divano rosa",
    "Chambre avec lit et commode" : "Camera da letto con letto e cassettiera",
    "Cuisine au mur rose" : "Cucina con parete rosa",
    "Poster encadré" : "Poster incorniciato",
    "Glissez pour faire pivoter · molette pour zoomer" : "Trascina per ruotare · rotellina per zoomare",
    "Molette pour zoomer" : "Rotellina per zoomare",
    "Vue d'ensemble" : "Vista d'insieme",
    "De près" : "Da vicino",
    "Dimensions" : "Dimensioni",
    "Pièce" : "Stanza",
    "Ensemble" : "Insieme",
    "Afficher les dimensions" : "Mostra le dimensioni",
    "Préparation de l'aperçu…" : "Preparazione dell'anteprima…",

    // posters : the size and finish screens, the editor's options bar
    "Les aperçus sont à la même échelle : comparez d'un coup d'œil." : "Le anteprime sono alla stessa scala: confrontale a colpo d'occhio.",
    "Choisissez votre finition" : "Scegli la tua finitura",
    "Comment voulez-vous l'afficher ?" : "Come vuoi esporlo?",
    "Aperçu avec votre photo, au format $." : "Anteprima con la tua foto, nel formato $.",
    "Le + choisi" : "Il più scelto",
    "Pas disponible dans cette taille" : "Non disponibile in questa misura",
    "Options du poster" : "Opzioni del poster",

    // album check before ordering (shared.panels.AlbumCheckPanel)
    "Vérification en cours…" : "Verifica in corso…",
    "Nous passons votre album en revue avant l'impression." : "Controlliamo il suo album prima della stampa.",
    "Votre conseillère Flexilivre" : "La sua consulente Flexilivre",
    "Votre album a été vérifié" : "Il suo album è stato verificato",
    "Corriger mon album" : "Correggere il mio album",
    "complété" : "completato",
    "Tout est parfait, votre album est prêt !" : "Tutto è perfetto, il suo album è pronto!",
    "Vous y êtes presque !" : "Ci siete quasi!",
    "Encore un petit effort !" : "Ancora un piccolo sforzo!",
    "Votre album prend forme" : "Il suo album prende forma",
    "Vérification des pages" : "Verifica delle pagine",
    "Pages remplies" : "Pagine riempite",
    "Nombre de pages" : "Numero di pagine",
    "1 zone photo vide" : "1 zona foto vuota",
    "$ zones photo vides" : "$ zone foto vuote",
    "imprimées en blanc si vous commandez" : "stampate in bianco se ordina",
    "1 page vide" : "1 pagina vuota",
    "$ pages vides" : "$ pagine vuote",
    "Une feuille sera ajoutée à la fin" : "Un foglio sarà aggiunto alla fine",
    "le nombre de pages n'est pas un multiple de 4" : "il numero di pagine non è un multiplo di 4",
    "Pages concernées" : "Pagine interessate",
    "p. $" : "p. $",
    "$ : validé" : "$: convalidato",
    "$ : problème détecté" : "$: problema rilevato",

    // first pages added (common.popups.AddPagePopup)
    "Conseillère Flexilivre" : "Consulente Flexilivre",
    "Psst ! $ pages" : "Psst! $ pagine",
    "Un album se fait par <strong>4 pages</strong>. Sinon, on complète avec des pages blanches lors de la fabrication." : "Un album si fa a gruppi di <strong>4 pagine</strong>. Altrimenti, completiamo con pagine bianche durante la produzione.",
    "OK, compris" : "OK, capito",
});
